import MuiDrawer from '@material-ui/core/Drawer';
import {Button} from '@wandb/weave/components';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import classNames from 'classnames';
import React, {ReactNode, useState} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {ResizableDrawer} from '../../Launch/ResizableDrawer';

type ContainerProps = {
  children: ReactNode;
  isInReport?: boolean | undefined;
};
export function Container({isInReport, children}: ContainerProps) {
  // Don't show a goofy about of whitespace at the top of the drawer, if we are
  // viewing this drawer from a report:
  const classes = classNames('flex h-full flex-col', {
    ['pt-60']: !isInReport,
  });
  return (
    <Tailwind style={{display: 'contents'}}>
      <div className={classes}>{children}</div>
    </Tailwind>
  );
}

type HeaderProps = {
  onClose?: null | (() => void);
  title: string;
};
export function Header({onClose, title}: HeaderProps) {
  return (
    <div className="flex flex-row items-center justify-between border-b border-moon-250 px-24 py-16">
      <div className="text-xl font-semibold leading-8">{title}</div>
      {onClose ? (
        <Button
          icon="close"
          variant="ghost"
          onClick={onClose}
          aria-label="Close drawer"
        />
      ) : null}
    </div>
  );
}

export function Body({children}: ContainerProps) {
  return (
    <div className="flex grow flex-col justify-center px-24 py-16">
      {children}
    </div>
  );
}

export function Footer({children}: ContainerProps) {
  return (
    <div className="flex shrink-0 grow-0 flex-row items-center justify-end gap-8 border-t border-moon-300 px-24 py-16">
      {children}
    </div>
  );
}

type DrawerProps = {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
};
export function Drawer({children, open, onClose}: DrawerProps) {
  // Note that the drawer container and the contents are separated here. The
  // rationale is that the material-ui drawer components are deprecated and
  // should eventually be replaced with something else. It should be easy to
  // make that migration here, if the drawer and drawer contents are separated.
  // Future development should avoid putting business logic in this component
  // to keep that separation of concerns as clear as possible.
  const [width, setWidth] = useState(480);

  return (
    <MuiDrawer anchor="right" open={open} onClose={onClose}>
      <ResizableDrawer startWidth={width} minWidth={480} onSetWidth={setWidth}>
        {children}
      </ResizableDrawer>
    </MuiDrawer>
  );
}

// TODO: eventually replace this with a Radix-based progress element
export const Progress = styled.progress`
  border-radius: 4px;
  background: rgba(13, 15, 18, 0.05);

  ::-webkit-progress-inner-element {
    border-radius: 4px;
    overflow: hidden;
  }
  ::-webkit-progress-bar {
    background: rgba(13, 15, 18, 0.05);
  }
  ::-moz-progress-bar {
    background: rgb(19, 169, 186);
  }
  ::-webkit-progress-value {
    background: rgb(19, 169, 186);
    transition: inline-size 200ms;
  }
`;
